import { BuildingMenuType } from '@/enums';
import { PATHS } from '@/router/paths';

export const DEFAULT_MENUS = [
    {
        type: BuildingMenuType.HOME,
        route: PATHS.HOME.INDEX,
    },
    {
        type: BuildingMenuType.FLOOR,
        route: PATHS.FLOOR_GUIDE.INDEX,
    },
    {
        type: BuildingMenuType.SEARCH,
        route: PATHS.SHOP.INDEX,
    },
];

export const MENU_CUSTOM = [
    {
        type: BuildingMenuType.CUSTOM_MENU_LIST_TYPE,
        route: PATHS.CUSTOM_MENU.LIST_TYPE,
    },
    {
        type: BuildingMenuType.CUSTOM_MENU_CARD_TYPE,
        route: PATHS.CUSTOM_MENU.CARD_TYPE,
    },
    {
        type: BuildingMenuType.CUSTOM_MENU_TOGGLE_TYPE,
        route: PATHS.CUSTOM_MENU.TOGGLE_TYPE,
    },
    {
        type: BuildingMenuType.CUSTOM_MENU_CATEGORY_TYPE,
        route: PATHS.CUSTOM_MENU.CATEGORY_TYPE,
    },
];

export const JAMSIL_MAP_IDS = ['e2048cd2-68f3-44fd-8310-0c30a43f6092'];

export const KEY_CODE_PAJU = ['02'];
export const KEY_CODE_BUSAN = ['03'];
export const KEY_CODE_SIHEUNG = ['05'];
